import { render, staticRenderFns } from "./YouthQuestionnare.vue?vue&type=template&id=437e52ba"
import script from "./YouthQuestionnare.vue?vue&type=script&lang=js"
export * from "./YouthQuestionnare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports